import { ReactNode, useEffect, useState } from "react";
import { useAuth } from "./providers/AuthProvider";
import { BootSplash } from "./BootSplash";

/**
 * Plays the premium NX boot splash once per authenticated app entry — on a
 * reload while a session exists, and right after a successful login. Never on
 * the login screen itself (no `user` -> splash never mounts, children never
 * inert). Sits inside AuthProvider. Spec A2. The splash no-ops in test /
 * VITE_DISABLE_BOOT_SPLASH.
 */
export function BootGate({ children }: { children: ReactNode }) {
  const { isLoading, user } = useAuth();
  const [played, setPlayed] = useState(false);

  const showSplash = !played && !isLoading && !!user;

  useEffect(() => {
    // Re-arm on any authenticated -> unauthenticated transition (logout,
    // session expiry) so the NEXT authenticated entry plays the splash again.
    // This is the mechanism that makes the splash replay after logout -> re-login
    // — it does not depend on the component remounting.
    if (!isLoading && !user) setPlayed(false);
  }, [isLoading, user]);

  return (
    <>
      <div style={{ display: "contents" }} inert={showSplash ? true : undefined}>
        {children}
      </div>
      {showSplash && <BootSplash onDone={() => setPlayed(true)} />}
    </>
  );
}
